import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { useSelector } from 'react-redux';

import configurations from '@/config';
import { getAccessToken } from '@/utils/api';

interface FetchHasWritebackRequest {
  currentPracticeId: string;
  currentOrganizationId: string;
}

const fetchHasWriteback = async ({
  currentPracticeId,
  currentOrganizationId,
}: FetchHasWritebackRequest) => {
  const { data } = await axios.get<{ hasWritebackSupport: boolean }>(
    `${configurations.API_URL}/videa-notes/writeback`,
    {
      headers: {
        Authorization: `Bearer ${getAccessToken()}`,
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
        practice: currentPracticeId,
        org: currentOrganizationId,
      },
    },
  );
  return data.hasWritebackSupport;
};

export const useHasWriteback = (enabled: boolean) => {
  const {
    primaryPracticeId: currentPracticeId,
    primaryOrganizationId: currentOrganizationId,
  } = useSelector((state: any) => state.login.user);

  return useQuery({
    queryKey: [
      'videa-notes-writeback',
      currentOrganizationId,
      currentPracticeId,
    ],
    queryFn: () => {
      return fetchHasWriteback({
        currentPracticeId,
        currentOrganizationId,
      });
    },
    enabled: !!currentPracticeId && !!currentOrganizationId && enabled,
  });
};
